export const STORY_CATEGORIES = [
  { value: 'childhood', label: 'Childhood Memories', icon: '👶' },
  { value: 'traditions', label: 'Family Traditions', icon: '🎄' },
  { value: 'achievements', label: 'Achievements', icon: '🏆' },
  { value: 'challenges', label: 'Challenges Overcome', icon: '💪' },
  { value: 'values', label: 'Values & Lessons', icon: '💡' },
  { value: 'wisdom', label: 'Words of Wisdom', icon: '📚' },
  { value: 'recipes', label: 'Family Recipes', icon: '🍳' },
  { value: 'other', label: 'Other Stories', icon: '📖' }
];

export const PRAYER_CATEGORIES = [
  { value: 'health', label: 'Health', icon: '🏥' },
  { value: 'family', label: 'Family', icon: '👨‍👩‍👧‍👦' },
  { value: 'guidance', label: 'Guidance', icon: '🧭' },
  { value: 'thanksgiving', label: 'Thanksgiving', icon: '🙏' },
  { value: 'protection', label: 'Protection', icon: '🛡️' },
  { value: 'provision', label: 'Provision', icon: '🌾' },
  { value: 'healing', label: 'Healing', icon: '💚' },
  { value: 'other', label: 'Other', icon: '✨' }
];
